/**
 * CSRF 토큰 유틸 — 레거시 fetch 호출(SSE POST 등) 에서 공통 사용.
 * axios api 인스턴스는 lib/api.ts 가 자동 부착하지만, raw fetch 는 직접 읽어야 함.
 */

export function getCsrfTokenFromCookie(): string | null {
  const match = document.cookie.match(/(?:^|;)\s*heinrich_csrf=([^;]*)/)
  return match ? decodeURIComponent(match[1]) : null
}

/**
 * fetch 옵션에 CSRF 토큰 + Authorization 을 주입한 표준 헤더를 반환.
 * 백엔드 /api/* 뮤테이션 경로는 반드시 이 헤더를 필요로 함.
 */
export function authFetchHeaders(extra: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = { ...extra }
  const csrf = getCsrfTokenFromCookie()
  if (csrf) headers['X-CSRF-Token'] = csrf
  return headers
}
